import React from 'react';
import { withRouter } from 'react-router';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';

import { InputField } from 'Common/SemanticWrapper';
import { FNS874_REPORT_FORM_NAME } from 'Common/FormEnum';
import { FNS742AReportFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';

function FNS874ReportFormContainer() {
  return (
    <Form name="FNS874ReportForm">
      <TitledCard title={'Report Parameters'}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              <Field
                component={InputField}
                label={'State Agency:'}
                name={Fields.StateAgency}
                maxLength={30}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                component={InputField}
                label={'SFA/LEA ID:'}
                name={Fields.SFAId}
                maxLength={30}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Field
                component={InputField}
                label={'SFA/LEA Name:'}
                name={Fields.SFAName}
                maxLength={30}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
}

const validate = values => {
  const errors = {};
  if (!values[Fields.StateAgency]) {
    errors[Fields.StateAgency] = 'State Agency is Required';
  }
  if (!values[Fields.SFAId]) {
    errors[Fields.SFAId] = 'SFA/LEA Id is Required';
  }
  if (!values[Fields.SFAName]) {
    errors[Fields.SFAName] = 'SFA/LEA Name is Required';
  }
  return errors;
};

export const FNS874ReportForm = reduxForm({
  form: FNS874_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(withRouter(FNS874ReportFormContainer));



// WEBPACK FOOTER //
// ./src/pages/fns874/components/FNS874ReportForm.js